import RadioField from 'components/formFields/radioField'
import CnpjField from 'components/formFields/cnpjField'
import CpfField from 'components/formFields/cpfField'
import EmailField from 'components/formFields/emailField'
import CurrencyField from 'components/formFields/currencyField'
import TextField from 'components/formFields/textField'
import DropdownField from 'components/formFields/dropdownField'
import DateField from 'components/formFields/dateField'
import StateField from 'components/formFields/stateField'
import CnaeField from 'components/formFields/cnaeField'
import CityField from 'components/formFields/cityField'
import CheckboxField from 'components/formFields/checkboxField'
import NumberField from 'components/formFields/numberField'
import PercentageField from 'components/percentageField'
import BankField from 'components/formFields/bankField'
import TimeField from 'components/formFields/timeField'
import ImageField from 'components/formFields/imageField'
import FileField from 'components/formFields/fileField'
import StructuredList from 'components/formFields/structuredList'
import StructuredCheckbox from 'components/structuredCheckbox'
import AddressField from 'components/addressField'
import DatabaseField from 'components/databaseField'
import TextDatabaseField from 'components/textDatabaseField'
import InternalDatabaseField from 'components/InternalDatabaseField'
import PersonField from 'components/personField'
import ParagraphCkeditorField from 'components/formFields/paragraphCkeditorField'
import ApiField from 'components/formFields/apiField'

export const inputTypes = {
	api: ApiField,
	radio: RadioField,
	cnpj: CnpjField,
	cpf: CpfField,
	email: EmailField,
	currency: CurrencyField,
	dropdown: DropdownField,
	date: DateField,
	time: TimeField,
	state: StateField,
	checkbox: CheckboxField,
	cnae: CnaeField,
	city: CityField,
	number: NumberField,
	percentage: PercentageField,
	bank: BankField,
	variable_image: ImageField,
	attachment: FileField,
	person: PersonField,
	address: AddressField,
	structured_list: StructuredList,
	structured_checkbox: StructuredCheckbox,
	database: DatabaseField,
	text_database: TextDatabaseField,
	internal_database: InternalDatabaseField,
	text_area_ckeditor: ParagraphCkeditorField,
	default: TextField,
}
